export default {"src":"/_next/static/media/settings.c6fd6229.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};